/* ==========================================================================
   CORALINO BEACHWEAR - CONTROLADOR JS PERSONALIZADO
   ========================================================================== */

window.openCoralSizeModal = function(e) {
  if (e && e.preventDefault) e.preventDefault();
  const modal = document.getElementById('CoralSizeModal');
  if (modal) {
    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    modal.style.display = 'flex';
    modal.style.opacity = '1';
    modal.style.pointerEvents = 'auto';
    document.body.style.overflow = 'hidden';
  }
};

window.closeCoralSizeModal = function(e) {
  if (e && e.preventDefault) e.preventDefault();
  const modal = document.getElementById('CoralSizeModal');
  if (modal) {
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    modal.style.display = 'none';
    modal.style.opacity = '0';
    modal.style.pointerEvents = 'none';
    document.body.style.overflow = '';
  }
};

window.setCoralSizeUnit = function(unit, e) {
  if (e && e.preventDefault) e.preventDefault();
  const isInch = (unit === 'in');

  document.querySelectorAll('.js-unit-toggle, .c-modal-unit-btn, .sp-unit-btn').forEach(function(b) {
    const bUnit = b.dataset.unit || b.getAttribute('data-unit');
    const isCur = (bUnit === unit);
    b.classList.toggle('is-active', isCur);
    b.setAttribute('aria-checked', isCur ? 'true' : 'false');
    if (isCur) {
      b.style.background = '#1C1716';
      b.style.color = '#FFFFFF';
      b.style.borderColor = '#1C1716';
    } else {
      b.style.background = '#FAF7F2';
      b.style.color = '#6E5A52';
      b.style.borderColor = '#EFE8DE';
    }
  });

  document.querySelectorAll('.js-active-unit-text').forEach(function(lbl) {
    lbl.textContent = isInch ? 'pulgadas (IN)' : 'centímetros (CMS)';
  });

  document.querySelectorAll('#CoralSizeModal .js-cell, .coral-brand-table .js-cell, .c-modal-brand-table .js-cell, [data-cm]').forEach(function(cell) {
    const cmVal = cell.dataset.cm || cell.getAttribute('data-cm');
    const inVal = cell.dataset.in || cell.getAttribute('data-in');
    const val = isInch ? inVal : cmVal;
    const unitLabel = isInch ? 'IN' : 'CMS';
    if (val) {
      cell.innerHTML = '<strong>' + val + '</strong> <span class="val-unit">' + unitLabel + '</span>';
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  // Inicialización de efectos de scroll y microinteracciones
  const initCoralinoTheme = () => {
    // Marcado de imágenes con fade-in suave al cargar
    const images = document.querySelectorAll('img');
    images.forEach(img => {
      if (img.complete) {
        img.classList.add('loaded');
      } else {
        img.addEventListener('load', () => img.classList.add('loaded'));
      }
    });

    // Control de encabezados con script cursivo
    document.querySelectorAll('.font-script').forEach(el => {
      el.style.display = 'inline-block';
    });
  };

  initCoralinoTheme();

  // ========================================================
  // CONTROLADOR GLOBAL DE PESTAÑAS (TABS) DE PRODUCTO
  // ========================================================
  document.addEventListener('click', (e) => {
    const tabBtn = e.target.closest('.js-tab-btn, .c-tab-btn');
    if (!tabBtn) return;
    e.preventDefault();

    const targetId = tabBtn.getAttribute('data-panel');
    const container = tabBtn.closest('.c-product-tabs-section') || document;

    container.querySelectorAll('.js-tab-btn, .c-tab-btn').forEach(b => b.classList.remove('is-active'));
    tabBtn.classList.add('is-active');

    container.querySelectorAll('.c-tab-panel').forEach(panel => {
      panel.classList.remove('is-active');
      panel.style.display = 'none';
    });

    const activePanel = container.querySelector('#' + targetId) || document.getElementById(targetId);
    if (activePanel) {
      activePanel.classList.add('is-active');
      activePanel.style.display = 'block';
    }
  });

  // ========================================================
  // CONTROLADOR GLOBAL: ABRIR DRAWER LATERAL EN VEZ DE SUBPÁGINA /cart
  // ========================================================
  document.addEventListener('click', (e) => {
    const cartTrigger = e.target.closest('a[href="/cart"], a[href$="/cart"], a[href*="/cart?"], #cart-icon-bubble, .cart-link-btn, .header-action-btn[href*="cart"]');
    if (cartTrigger) {
      e.preventDefault();
      e.stopPropagation();
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.classList.remove('is-empty');
        if (typeof drawer.open === 'function') {
          drawer.open(cartTrigger);
        } else {
          drawer.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
        }
      }
    }
  }, true);

  // Apertura ultra-instantánea a 0ms para cualquier formulario de compra en toda la tienda
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.remove('is-empty');
      const inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      if (typeof drawer.open === 'function') {
        drawer.open();
      } else {
        drawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      }
    }
  }, true);

  // Si se aterriza en la URL /cart por acceso directo o tipeo, redirigir instantáneamente y abrir el Drawer
  if (window.location.pathname === '/cart' || window.location.pathname.endsWith('/cart')) {
    const ref = document.referrer;
    if (ref && !ref.includes('/cart')) {
      window.location.replace(ref + (ref.includes('?') ? '&' : '?') + 'open_drawer=true');
    } else {
      window.location.replace('/?open_drawer=true');
    }
  }

  // Auto-apertura si proviene de redirección
  if (window.location.search.includes('open_drawer=true')) {
    let attempts = 0;
    const checkAndOpen = setInterval(() => {
      attempts++;
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.classList.remove('is-empty');
        if (typeof drawer.open === 'function') {
          drawer.open();
          clearInterval(checkAndOpen);
        } else {
          drawer.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
          clearInterval(checkAndOpen);
        }
      }
      if (attempts > 20) clearInterval(checkAndOpen);
    }, 150);
  }
});